/* globals _, CUAC_SETTINGS, DEBUG, PROD, console */
"use strict";

import _ from "lodash";
import React from "react";
import { FormattedMessage, FormattedDate, FormattedTime } from "react-intl";
import InfoBug from "components/popover/infobug";

import { TrackerTypes } from "api/tracker-entries";
import Accordion from "components/ux/accordion";
import Button from "components/ux/mdl/button";
import {
  faChevronCircleDown,
  faChevronCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
export const ABCList = React.createClass({
  propTypes: {
    tag: React.PropTypes.string,
    trackerEntries: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      openEntries: [],
    };
  },

  toggleEntry(index) {
    let openEntries = this.state.openEntries;
    if (openEntries.indexOf(index) == -1) {
      openEntries.push(index);
    } else {
      openEntries = _.without(openEntries, index);
    }

    this.setState({
      openEntries: openEntries,
    });
  },

  render() {
    const { tag, trackerEntries } = this.props;
    const locus = this,
      openEntries = this.state.openEntries,
      toggleEntry = this.toggleEntry;
    const fullOrder = _.get(trackerEntries, TrackerTypes.ABC + "Order", []);
    const fullOrderEntries = _.map(fullOrder, (trackerEntryId) => {
      return _.get(trackerEntries, trackerEntryId, {});
    });
    const filteredEntries =
      typeof tag !== "undefined"
        ? _.filter(fullOrderEntries, (trackerEntry) => {
            return _.get(trackerEntry, "tag") === tag;
          })
        : fullOrderEntries;
    const orderEntries = filteredEntries.slice(0, 20);

    return (
      <div className="section section-tracker-list col-1-1">
        <div
          className="contain-box-wrap"
          style={{ maxWidth: "690px", marginTop: "20px" }}
        >
          <div className="contain-box-main">
            <h3 className="section-title contain-box-title">
              <FormattedMessage
                id="abc_list_title"
                defaultMessage="Your Recent ABCs"
              />
            </h3>
            <div className="tracker-list-data">
              <div className="tracker-episode header">
                <div className="tracker-row">
                  <div className="tracker-entry tracker-entry-type">
                    <FormattedMessage
                      id="abc_data_header_title"
                      defaultMessage="Title"
                    />
                  </div>
                  <div className="tracker-entry tracker-entry-date-time">
                    <FormattedMessage
                      id="drink_data_header_date"
                      defaultMessage="Last Updated"
                    />
                  </div>

                  <div className="clearfix" />
                </div>
              </div>
              {orderEntries.map((fullTrackerEntry, index) => {
                const trackerEntry = _.get(fullTrackerEntry, "data", {});
                const dateUpdated = new Date(fullTrackerEntry.dt_u),
                  isOpen = openEntries.indexOf(index) !== -1,
                  accordionButton =
                    "accordion-toggle" + (isOpen ? " open" : ""),
                  accordionButtonIcon = isOpen
                    ? faChevronCircleDown
                    : faChevronCircleRight;

                return !_.isEmpty(trackerEntry) ? (
                  <div className="tracker-episode" key={"abc_" + index}>
                    <div className="tracker-row">
                      <Button
                        className={accordionButton}
                        flat={true}
                        onClick={toggleEntry.bind(locus, index)}
                        style={{ float: "left" }}
                      >
                        <FontAwesomeIcon icon={accordionButtonIcon} />
                      </Button>
                      <div
                        className="tracker-entry tracker-entry-date-time"
                        style={{ display: "inline-block" }}
                      >
                        <div
                          className="tracker-date px-4"
                          style={{ display: "inline-block" }}
                        >
                          <FormattedDate
                            value={dateUpdated}
                            day="numeric"
                            month="short"
                            year="numeric"
                          />
                        </div>
                        <div
                          className="tracker-time px-4"
                          style={{ display: "inline-block" }}
                        >
                          <FormattedTime
                            value={dateUpdated}
                            hour="numeric"
                            minute="numeric"
                          />
                        </div>
                      </div>
                      <div
                        className="tracker-entry tracker-entry-title px-4"
                        style={{ display: "inline-block" }}
                      >
                        {trackerEntry.title}
                      </div>
                      <Accordion
                        collapsed={!isOpen}
                        className="tracker-entry-block"
                      >
                        <div>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_title_label"
                                defaultMessage="Title"
                              />
                            </span>
                            {trackerEntry.title}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_activating_event_label"
                                defaultMessage="A: Activating Event"
                              />
                            </span>
                            {trackerEntry.activating_event}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_beliefs_label"
                                defaultMessage="B: Beliefs, Expectancies, Or Thoughts"
                              />
                            </span>
                            {trackerEntry.beliefs}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_consequences_label"
                                defaultMessage="C: Consequences"
                              />
                            </span>
                            {trackerEntry.consequences}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_dispute_label"
                                defaultMessage="D: Dispute"
                              />
                            </span>
                            {trackerEntry.dispute}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_effective_new_belief_label"
                                defaultMessage="E: Effective New Belief"
                              />
                            </span>
                            {trackerEntry.effective_new_belief}
                          </p>
                          <p className="tracker-entry-p">
                            <span className="tracker-entry-label">
                              <FormattedMessage
                                id="abc_tracker_entry_emotional_consequence_label"
                                defaultMessage="F: Emotional Consequence"
                              />
                            </span>
                            {trackerEntry.emotional_consequence}
                          </p>
                        </div>
                      </Accordion>
                      <div className="clearfix" />
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  },
});
